import loadGoogleMaps from'./helper';import VuetifyGoogleAutocomplete from'./VuetifyGoogleAutocomplete';if(typeof window!=='undefined'){window.vgaMapState={initMap:false};window.initVGAMaps=function(){window.vgaMapState.initMap=true}}VuetifyGoogleAutocomplete.install=function(Vue,options){if(options.apiKey){loadGoogleMaps(options.apiKey,options.version,options.language)}Vue.component(VuetifyGoogleAutocomplete.name,VuetifyGoogleAutocomplete)};export default VuetifyGoogleAutocomplete;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify-google-autocomplete/lib/index.js
// module id = 1581
// module chunks = 0